import React from 'react';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const CostBreakdownChart = ({ envCosts, networkCosts, storageCosts, managedServices }) => {
  // Calculate category totals
  const totals = {
    environment: Object.values(envCosts).reduce((sum, cost) => sum + cost, 0),
    network: Object.values(networkCosts).reduce((sum, cost) => sum + cost, 0),
    storage: Object.values(storageCosts).reduce((sum, cost) => sum + cost, 0),
    managedServices: managedServices
  };

  // Calculate grand total for percentages
  const grandTotal = Object.values(totals).reduce((sum, cost) => sum + cost, 0);

  // Prepare data for pie chart
  const data = [
    {
      name: 'Environment',
      value: totals.environment,
      percentage: ((totals.environment / grandTotal) * 100).toFixed(1),
      color: '#60A5FA'  // blue
    },
    {
      name: 'Network',
      value: totals.network,
      percentage: ((totals.network / grandTotal) * 100).toFixed(1),
      color: '#34D399'  // green
    },
    {
      name: 'Storage',
      value: totals.storage,
      percentage: ((totals.storage / grandTotal) * 100).toFixed(1),
      color: '#F97316'  // orange
    },
    {
      name: 'Managed Services',
      value: totals.managedServices,
      percentage: ((totals.managedServices / grandTotal) * 100).toFixed(1),
      color: '#818CF8'  // indigo
    }
  ];

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h3 className="text-lg font-medium text-gray-900 mb-4">Cost Distribution</h3>
      <ResponsiveContainer width="100%" height={300}>
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            innerRadius={60}
            outerRadius={100}
            paddingAngle={5}
            dataKey="value"
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>
          <Tooltip 
            formatter={(value, name) => [
              `$${value.toFixed(2)} (${data.find(d => d.name === name).percentage}%)`,
              name
            ]}
          />
          <Legend 
            formatter={(value, entry) => (
              `${value} ${data.find(d => d.name === value).percentage}%`
            )}
          />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default CostBreakdownChart;